module.exports = __webpack_public_path__ + "img/cloth_g1_shirt_06.9e90dfcb.svg";